import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setCampaignId } from '../../../lib/redux/campaignFilter/campaignFilterSlice';

export const useCampaignFilter = () => {
  const campaignId = useSelector(state => state.campaignFilter.campaignId);
  const dispatch = useDispatch();

  const setNewCampaignId = useCallback(
    newCampaignId => dispatch(setCampaignId(newCampaignId)),
    [dispatch],
  );

  return {
    campaignId,
    setCampaignId: setNewCampaignId,
  };
};
